<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <div
      class="grid gap-x-3 overflow-hidden"
      style="grid-template-columns: 25% 1fr"
    >
      <div class="overflow-hidden pr-3">
        <div class="flex flex-col gap-y-2 overflow-y-auto">
          <ul class="flex gap-x-3 items-center">
            <strong>{{ state.model?.number }}</strong>
            <text class="text-gray-400 text-xs">采购付款</text>
            <!-- <text v-if="state.model?.status == 0" class="text-xs">
              {{ state.model?.flowApproveStep?.step_name }}
            </text> -->
            <c_status
              arrName="Office_Expense_Apply_Status"
              :value="state.model?.status"
              :key="state.model?.status"
              showBg
            />
          </ul>
          <c_cell title="付款金额">
            <c_money
              :key="state.model.amount"
              :value="state.model.amount"
              :size="20"
              :prefix="false"
              bold
            />
          </c_cell>
          <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
          <c_cell
            title="所属会议"
            :value="state.meeting?.name"
            class="items-baseline"
          >
            <div
              class="flex gap-x-3 items-center flex-wrap"
              v-if="state.meeting?.id"
            >
              <text>{{ state.meeting?.name }}</text>
              <text class="text-gray-400 text-xs">{{
                state.meeting?.number
              }}</text>
              <c_status
                arrName="Meeting_Status"
                :value="state.meeting?.status"
                :key="state.meeting?.status"
                showBg
              />
            </div>
            <text v-else>-</text>
          </c_cell>
          <c_cell title="收款信息">
            <template #default>
              <div
                class="flex gap-x-2"
                v-if="state.model?.is_supplier_purchase"
              >
                <text>{{
                  state.model?.supplierBankAccount?.opening_bank
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.supplierBankAccount?.name
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.supplierBankAccount?.account
                }}</text>
              </div>
              <div class="flex gap-x-2" v-else>
                <text>{{ state.model?.opening_bank }}</text>
                <text class="text-gray-400">{{
                  state.model?.bank_account_name
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.bank_account
                }}</text>
              </div>
            </template>
          </c_cell>
          <c_cell title="申请说明" :value="state.model?.intro" />
          <c_cell title="附件">
            <template #default>
              <div
                class="flex flex-wrap gap-x-5 gap-y-2"
                v-if="state.model?.attachment?.length > 0"
              >
                <text
                  v-for="file in state.model?.attachment"
                  :key="item"
                  class="hover:underline cursor-pointer text-green-700"
                  @click="$openFile(file.file_url)"
                >
                  {{ file.filename }}
                </text>
              </div>
              <text v-else>-</text>
            </template>
          </c_cell>
          <ul class="text-gray-400 text-xs">
            审核进度：
          </ul>
          <el-timeline class="!text-xs" style="padding-left: 5px">
            <el-timeline-item
              :hollow="item.status == 0"
              :type="
                item.status === 0
                  ? 'info'
                  : item.status === 1
                  ? 'primary'
                  : 'danger'
              "
              hide-timestamp
              v-for="item in state.flowApproveStepList"
              :key="item"
            >
              <div class="flex gap-x-3 flex-wrap gap-y-1">
                <strong>{{ item.step_name }}</strong>
                <c_status
                  arrName="Common_Check_Status"
                  :value="item?.log?.status"
                />
                <template v-if="item.status">
                  <text>{{ item?.log?.add_admin_name }}</text>
                  <text class="text-gray-400">{{
                    item?.log?.add_department_name
                  }}</text>
                  <text class="text-gray-400">{{
                    item?.log?.create_time
                  }}</text>
                </template>
              </div>
              <c_cell
                title="操作说明"
                v-if="item?.log?.msg && item?.log?.status != 4"
                class="mt-1"
                :size="12"
              >
                {{ item?.log?.msg }}
              </c_cell>
            </el-timeline-item>
            <el-timeline-item
              type="primary"
              hide-timestamp
              v-if="state.model?.status == 2"
            >
              <div class="flex gap-x-3 flex-wrap gap-y-1">
                <strong>付款</strong>
                <c_status
                  arrName="Office_Expense_Apply_Status"
                  :value="state.model?.status"
                  :key="state.model?.status"
                />
                <text>{{ state.model?.transaction_admin_name }}</text>
                <text class="text-gray-400">{{
                  state.model?.transaction_department_name
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.transaction_time
                }}</text>
              </div>
              <c_cell
                title="付款说明"
                v-if="state.model?.transaction_remark"
                class="mt-1"
                :size="12"
              >
                {{ state.model?.transaction_remark }}
              </c_cell>
              <c_cell
                title="附件"
                v-if="state.model?.transaction_remark"
                class="mt-1"
                :size="12"
              >
                <c_UploadFile
                  :key="state.model?.transaction_attachment"
                  :value="state.model?.transaction_attachment"
                  :showAdd="false"
                  :showText="true"
                />
              </c_cell>
            </el-timeline-item>
          </el-timeline>
        </div>
        <el-form
          v-if="state.model.status == 1"
          :model="state.check"
          label-width="auto"
          label-position="top"
          ref="formDom"
          size="large"
        >
          <el-form-item label="付款说明">
            <el-input v-model="state.check.remark" type="textarea"></el-input>
          </el-form-item>
          <el-form-item
            label="附件"
            class="!flex flex-col"
            prop="files"
            :rules="[
              { required: true, message: '请上传附件', trigger: 'blur' },
            ]"
          >
            <template #label>
              <div class="flex items-center float-right">
                <text>附件</text>
                <el-upload
                  :show-file-list="false"
                  :auto-upload="false"
                  multiple
                  :on-change="onFileChange"
                >
                  <el-button type="primary" size="small" link icon="plus">
                    上传
                  </el-button>
                </el-upload>
              </div>
            </template>
            <div class="w-full flex flex-wrap gap-x-5 gap-y-2">
              <li
                v-for="(file, index) in state.check.files"
                class="grid items-center hover:underline cursor-pointer text-green-700"
                style="grid-template-columns: 1fr auto"
                @click="$openFile(file.file_url)"
              >
                <text>{{ file.origin_filename }}</text>
                <el-icon
                  color="#f00"
                  @click.stop="state.check.files?.splice(index, 1)"
                  class="hover:scale-110 text-red-400 cursor-pointer ml-2"
                >
                  <Close />
                </el-icon>
              </li>
            </div>
          </el-form-item>
          <ul class="text-center w-full">
            <el-button type="primary" class="w-full" @click="onSubmit"
              >确定支付</el-button
            >
          </ul>
        </el-form>
      </div>
      <div class="flex flex-col mb-12 overflow-hidden">
        <strong>采购明细</strong>
        <div class="flex-1 overflow-y-auto mt-2 pr-3">
          <el-card
            v-for="(row, index) in state.list_data"
            :key="row"
            class="mb-3"
          >
            <template #header>
              <div class="flex gap-x-5">
                <strong>{{ index + 1 + "." + row.number }}</strong>
                <c_cell title="结算价">
                  <c_money
                    :value="row.amount"
                    :prefix="false"
                    :size="14"
                    color="#1e90ff"
                  />
                </c_cell>
                <c_cell title="已付">
                  <c_money
                    :value="row.paid_amount"
                    :prefix="false"
                    :size="14"
                    color="#080"
                  />
                </c_cell>
                <c_cell title="应付">
                  <c_money
                    :value="row.unpaid_amount"
                    :prefix="false"
                    :size="14"
                    color="#ffa500"
                  />
                </c_cell>
                <c_cell title="本次付款" class="flex-1">
                  <c_money
                    :value="row.this_amount"
                    :prefix="false"
                    :size="18"
                    bold
                  />
                </c_cell>
                <div class="flex items-center text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </div>
            </template>
            <table class="w-full" cellpadding="10">
              <thead>
                <tr class="text-left bg-gray-100">
                  <th style="width: 12%">所属分会</th>
                  <th style="width: 6%">类型</th>
                  <th style="width: 15%">名称</th>
                  <th style="width: 15%">规格</th>
                  <th style="width: 6%" class="text-center">单位</th>
                  <th style="width: 10%" class="text-center">单价</th>
                  <th style="width: 6%" class="text-center">数量</th>
                  <th style="width: 10%" class="text-center">合计</th>
                  <th>备注</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in row.meetingPurchaseItemData?.list"
                  :key="item"
                >
                  <td>{{ item.meetingPlace?.name }}</td>
                  <td>{{ item.d_cost_type_pname }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.specification || "-" }}</td>
                  <td class="text-center">
                    {{ item.d_measure_unit_name || "-" }}
                  </td>
                  <td class="text-center">{{ item.bill_price }}</td>
                  <td class="text-center">{{ item.bill_count }}</td>
                  <td class="text-center">{{ item.bill_amount }}</td>
                  <td>{{ item.bill_remark || "-" }}</td>
                </tr>
              </tbody>
            </table>
          </el-card>
        </div>
      </div>
    </div>

    <!-- <el-form
      v-if="state.model.status == 1"
      :model="state.check"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
    >
      <el-form-item label="付款说明">
        <el-input v-model="state.check.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="附件" class="!flex flex-col">
        <template #label>
          <div class="flex items-center float-right">
            <text>附件</text>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              multiple
              :on-change="onFileChange"
            >
              <el-button type="primary" size="small" link icon="plus">
                上传
              </el-button>
            </el-upload>
          </div>
        </template>
        <div class="w-full flex flex-wrap gap-x-5 gap-y-2">
          <li
            v-for="(file, index) in state.check.files"
            class="grid items-center hover:underline cursor-pointer text-green-700"
            style="grid-template-columns: 1fr auto"
            @click="$openFile(file.file_url)"
          >
            <text>{{ file.origin_filename }}</text>
            <el-icon
              color="#f00"
              @click.stop="state.check.files?.splice(index, 1)"
              class="hover:scale-110 text-red-400 cursor-pointer ml-2"
            >
              <Close />
            </el-icon>
          </li>
        </div>
      </el-form-item>
      <ul class="text-center">
        <el-button type="primary" @click="onSubmit">确定支付</el-button>
      </ul>
    </el-form>
    <ul class="flex gap-x-3 items-center">
      <strong>{{ state.model?.number }}</strong>
      <text class="text-gray-400 text-xs">采购付款</text>
      <c_money
        :key="state.model.amount"
        :value="state.model.amount"
        :size="20"
        bold
      />
    </ul>
    <ul class="flex gap-x-5">
      <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
      <c_cell title="收款信息">
        <template #default>
          <div class="flex gap-x-2" v-if="state.model?.is_supplier_purchase">
            <text>{{ state.model?.supplierBankAccount?.opening_bank }}</text>
            <text class="text-gray-400">{{
              state.model?.supplierBankAccount?.name
            }}</text>
            <text class="text-gray-400">{{
              state.model?.supplierBankAccount?.account
            }}</text>
          </div>
          <div class="flex gap-x-2" v-else>
            <text>{{ state.model?.opening_bank }}</text>
            <text class="text-gray-400">{{
              state.model?.bank_account_name
            }}</text>
            <text class="text-gray-400">{{ state.model?.bank_account }}</text>
          </div>
        </template>
      </c_cell>
    </ul>
    <c_cell title="申请说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <div
          class="flex flex-wrap gap-x-5 gap-y-2"
          v-if="state.model?.attachment?.length > 0"
        >
          <text
            v-for="file in state.model?.attachment"
            :key="item"
            class="hover:underline cursor-pointer text-green-700"
            @click="$openFile(file.file_url)"
          >
            {{ file.filename }}
          </text>
        </div>
        <text v-else>-</text>
      </template>
    </c_cell>
    <template v-if="state.model.status == 2">
      <c_cell title="付款说明" :value="state.model.transaction_remark" />
      <c_cell title="付款附件">
        <template #default>
          <div
            class="flex flex-wrap gap-x-5 gap-y-2"
            v-if="state.model?.transaction_attachment?.length > 0"
          >
            <text
              v-for="file in state.model?.transaction_attachment"
              :key="item"
              class="hover:underline cursor-pointer text-green-700"
              @click="$openFile(file.file_url)"
            >
              {{ file.filename }}
            </text>
          </div>
          <text v-else>-</text>
        </template>
      </c_cell>
      <div class="flex items-center text-gray-400 text-xs gap-x-2">
        <text class="text-sm text-gray-600">
          {{ state.model?.transaction_admin_name }}
        </text>
        <text>{{ state.model?.transaction_department_name }}</text>
        <text class="ml-1">{{ state.model?.transaction_time }} 付款</text>
      </div>
    </template>
    <strong>采购明细</strong>
    <div>
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        height="auto"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          align="center"
        />
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="采购名称"
              label2="采购单号/类型/创建人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <strong>{{ row.name }}</strong>
                <text class="text-xs text-gray-400 ml-1">{{ row.number }}</text>
                <text class="text-xs text-gray-400 ml-1">
                  {{ row.d_cost_type_pname }}
                </text>
              </template>
              <template #bottom>
                <div class="flex items-center text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :min-width="160">
          <template #header>
            <div
              class="c-table-col-header"
              label1="所属会议"
              label2="状态/项目编号"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.meeting?.name" :value2="row.number">
              <template #bottom>
                <div class="flex gap-x-2">
                  <c_status
                    arrName="Meeting_Status"
                    :value="row.meeting?.status"
                    :key="row.meeting?.status"
                  />
                  <text class="text-xs text-gray-400">{{
                    row.meeting?.number
                  }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="结算价" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-red-500">{{ $priceFormat(row.amount) }}</text>
          </template>
        </el-table-column>
        <el-table-column label="已付" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-blue-400">{{
              $priceFormat(row.paid_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="应付"
          prop="unpaid_amount"
          :width="120"
          align="center"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="本次付款" fixed="right" align="right">
          <template #default="{ row }">
            <el-input-number
              v-model="row.this_amount"
              :precision="2"
              class="number-input-left number-input-suffix !w-28"
              suffix="元"
              @focus="$onFocus"
              disabled
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <strong>审核进度</strong>
    <el-steps :active="10" align-center>
      <el-step
        v-for="item in state.flowApproveStepList"
        :key="item"
        :title="item.step_name"
        :description="state.model.create_time"
      >
        <template #description>
          <div class="flex flex-col items-center">
            <template v-if="item.status">
              <ul class="flex gap-x-1">
                <c_status
                  arrName="Common_Check_Status"
                  :value="item.status"
                  showBg
                />
                <text>{{ item.approve_admin_name }}</text>
                <text>{{ item.approve_department_name }}</text>
              </ul>
              <text>{{ item.approve_time }}</text>
            </template>
            <c_status
              v-else
              arrName="Common_Check_Status"
              :value="item.status"
              showBg
            />
          </div>
        </template>
      </el-step>
    </el-steps> -->
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meetingpurchasepaymentapply_search,
  meetingpurchasepaymentapply_pay,
} from "@/http/fukuanshenpi";
import { ElMessage, ElMessageBox } from "element-plus";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      list_data: [],
      check: {
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        meetingpurchasepaymentapply_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, meeting, meetingPurchaseList, flowApproveStepList } =
              res.data?.data || {};
            state.model = info;
            state.meeting = meeting;
            state.list_data = meetingPurchaseList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    });

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.check.files = [...state.check.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
            `您确定<strong style="color: #080">支付</strong>吗？`,
            "付款",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              dangerouslyUseHTMLString: true,
              cancelButtonClass: "is-plain",
            },
          ).then(() => {
            meetingpurchasepaymentapply_pay({
              id: props.id,
              transaction_remark: state.check.remark,
              transaction_attachment: JSON.stringify(
                state.check?.files?.map((m) => m.id),
              ),
            }).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };
    return { state, formDom, onFileChange, onSubmit };
  },
};
</script>
<style scoped></style>
